import { SelectLabel, Icon } from '@weezevent/nacre';
import React from 'react';
import Style from './selectLabelIcon.module.css';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function SelectLabelIcon({ label = '', placeholder = '', value, onChange = () => {}, options = [], disabelDescriptionInInput = false, errors, onBlur }) {
    const { t } = useTranslation();
    return (
        <SelectLabel
            label={t('ticket.cross-selling.add.category')}
            placeholder={t('ticket.common.action.select')}
            value={value}
            errors={errors}
            onChange={onChange}
            onBlur={onBlur}
            options={options.map(obj => {
                return {
                    text: (
                        <div className={Style['add-cross-selling-select-category']}>
                            <div>
                                <Icon className={Style['add-cross-selling-select-category-icon']} circular={true} name={obj.icon}></Icon>
                            </div>

                            <div>
                                <div className={Style['add-cross-selling-select-category-name']}>{obj.name}</div>
                                <div className={Style['add-cross-selling-select-category-description'] + (disabelDescriptionInInput ? ' disabelDescription' : '')}>
                                    {obj.description}
                                </div>
                            </div>
                        </div>
                    ),
                    value: obj.value
                };
            })}
        />
    );
}

SelectLabelIcon.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    options: PropTypes.array,
    disabelDescriptionInInput: PropTypes.bool
};
